'use client';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="flex-grow mt-16">
      {children}
    </div>
  );
} 